import dayjs from 'dayjs';

// Importar plugins necesarios
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { estadosAlarma } from "./definiciones";

let maxEstadosValue = 0;
let maxMovimientosValue = 0;

// Activar los plugins para dayjs
dayjs.extend(utc);
dayjs.extend(timezone);


// /* Procesa los strings con el estado de las zonas de la alarma */
// export const procesarTramaZonas = (registro) => {

//     const trama = registro.zonas;
//     // 1. Separamos por zonas (*) y eliminamos entradas vacías
//     // (el último * suele dejar un string vacío al final)
//     const zonasRaw = trama.split('*').filter(z => z.length > 0);

//     // 2. Mapeamos cada string de zona a un objeto
//     const arrayZonas = zonasRaw.map(zonaStr => {
//         const params = zonaStr.split('!');

//         return {
//             // parseInt(valor, 16) convierte de Hexadecimal a Decimal Entero
//             numZona: parseInt(params[0], 16),
//             estadoZona: parseInt(params[1], 16),
//             estadoBinario: parseInt(params[2], 16),
//             timeAnormal: parseInt(params[3], 16),
//             cuentaParcial: parseInt(params[4], 16),
//             cuentaTotal: parseInt(params[5], 16)
//         };
//     });

//     return arrayZonas;
// }

/* Procesa la información de zonas, soportando el formato antiguo (V6),
   el nuevo formato crudo tokenizado (V7+) y arrays JSON pre-procesados */
   export const procesarTramaZonas = (registro) => {
    const trama = registro.zonas;

    // Validación de seguridad inicial
    if (!trama) return [];

    // CASO 1: Viene de la Base de Datos como JSON Array (Implementación nueva de Node.js)
    // El backend ya hizo el JSON.parse() y ya convirtió el Hexadecimal a Decimal
    if (Array.isArray(trama) || (typeof trama === 'string' && trama.startsWith('['))) {
        // Nos aseguramos de que sea un array de JS
        const arrayZonas = typeof trama === 'string' ? JSON.parse(trama) : trama;
        //console.log("arrayZonas:", arrayZonas);

        return arrayZonas.map(params => ({
            numZona: params.numZona,       // NO usamos parseInt(..., 16) porque el backend ya lo hizo
            estadoZona: params.estadoZona,
            estadoBinario: params.estadoBinario,
            timeAnormal: params.timeAnormal,
            cuentaParcial: params.cuentaParcial,
            cuentaTotal: params.cuentaTotal
        }));
    }

    // CASO 2: Retrocompatibilidad - Formato antiguo V6 (separado por '*' y '!')
    if (typeof trama === 'string' && (trama.includes('*') || trama.includes('!'))) {
        const zonasRaw = trama.split('*').filter(z => z.length > 0);
        
        return zonasRaw.map(zonaStr => {
            const params = zonaStr.split('!');
            return {
                numZona: parseInt(params[0], 16),
                estadoZona: parseInt(params[1], 16),
                estadoBinario: parseInt(params[2], 16),
                timeAnormal: parseInt(params[3], 16),
                cuentaParcial: parseInt(params[4], 16),
                cuentaTotal: parseInt(params[5], 16)
            };
        });
    }

    // CASO 3: Formato Nuevo Tokenizado crudo (separado por ';' y ',')
    // Por si el frontend procesa el string puro que llega por WebSockets
    if (typeof trama === 'string') {
        const zonasRaw = trama.split(';').filter(z => z.trim().length > 0);

        return zonasRaw.map(zonaStr => {
            const params = zonaStr.split(',');

            return {
                numZona: parseInt(params[0], 16),
                estadoZona: parseInt(params[1], 16),
                estadoBinario: parseInt(params[2], 16),
                timeAnormal: parseInt(params[3], 16),
                cuentaParcial: parseInt(params[4], 16),
                cuentaTotal: parseInt(params[5], 16)
            };
        });
    }

    // Si llega un formato irreconocible, devolvemos array vacío para no romper la UI
    return [];
};

export const procesarTramaLuces = (registro) => {
    const trama = registro.salAC;

    // Validación de seguridad inicial
    if (!trama) return [];

    // CASO 1: Viene de la Base de Datos como JSON Array
    // El backend ya hizo el JSON.parse() y ya convirtió el Hexadecimal a Decimal
    if (Array.isArray(trama) || (typeof trama === 'string' && trama.startsWith('['))) {
        // Nos aseguramos de que sea un array de JS
        const arrayLuces = typeof trama === 'string' ? JSON.parse(trama) : trama;

        return arrayLuces.map(params => ({
            numLuz: params.numLuz,       // NO usamos parseInt(..., 16) porque ya es numérico
            estadoLuz: params.estadoLuz
        }));
    }

    // CASO 2: Retrocompatibilidad - Formato antiguo V6 (separado por '*' y '!')
    if (typeof trama === 'string' && (trama.includes('*') || trama.includes('!'))) {
        const lucesRaw = trama.split('*').filter(l => l.length > 0);
        
        return lucesRaw.map(luzStr => {
            const params = luzStr.split('!');
            return {
                numLuz: parseInt(params[0], 16),
                estadoLuz: parseInt(params[1], 16)
            };
        });
    }

    // CASO 3: Formato Nuevo Tokenizado crudo (separado por ';' y ',')
    // Por si el frontend procesa el string puro que llega por WebSockets
    if (typeof trama === 'string') {
        const lucesRaw = trama.split(';').filter(l => l.trim().length > 0);

        return lucesRaw.map(luzStr => {
            const params = luzStr.split(',');

            return {
                numLuz: parseInt(params[0], 16),
                estadoLuz: parseInt(params[1], 16)
            };
        });
    }

    // Si llega un formato irreconocible, devolvemos array vacío para no romper la UI
    return [];
};

export const procesarTramaPuertas = (registro) => {
    const trama = registro.puertas;

    if (!trama) return [];

    // CASO 1: Viene de la Base de Datos como JSON Array
    if (Array.isArray(trama) || (typeof trama === 'string' && trama.startsWith('['))) {
        try {
            // INTENTAMOS parsear el JSON
            const arrayPuertas = typeof trama === 'string' ? JSON.parse(trama) : trama;

            return arrayPuertas.map(params => ({
                numPuerta: params.numPuerta,
                estadoBinario: params.estadoBinario,
                timeAnormal: params.timeAnormal,
                estadoFlujo: params.estadoFlujo,
                timer: params.timer,
                resultadoApertura: params.resultadoApertura,
                metodoApertura: params.metodoApertura,
                usuarioApertura: params.usuarioApertura
            }));
        } catch (error) {
            // SI FALLA (ej: string cortado a la mitad), atrapamos el error para no romper la app
            //console.warn("⚠️ Error parseando trama de puertas (posible JSON incompleto). Registro ignorado:", trama);
            return []; 
        }
    }

    // CASO 2: Retrocompatibilidad formato antiguo
    if (typeof trama === 'string' && (trama.includes('*') || trama.includes('!'))) {
        const puertasRaw = trama.split('*').filter(p => p.length > 0);
        return puertasRaw.map(puertaStr => {
            const params = puertaStr.split('!');
            return {
                numPuerta: parseInt(params[0], 16),
                estadoBinario: parseInt(params[1], 16),
                timeAnormal: parseInt(params[2], 16),
                estadoFlujo: parseInt(params[3], 16),
                timer: parseInt(params[4], 16),
                resultadoApertura: parseInt(params[5], 16),
                metodoApertura: parseInt(params[6], 16),
                usuarioApertura: parseInt(params[7], 16)
            };
        });
    }

    return [];
};

/**
 * Genera el objeto 'series' para ApexCharts
 * @param {Array} arrayRegistros - Tu array con 100 objetos (con .date y .zonas)
 * @param {Array} infoZonas - Tu array de configuración (con .nZona y .nombre)
 * @returns {Array} Formato [{ name: 'Sala', data: [[timestamp, valor], ...] }]
 */
export function generarSeriesZonas(arrayRegistros, infoZonas) {

    //console.log("generarSeriesZonas -> arrayRegistros: ", arrayRegistros);
    //console.log("generarSeriesZonas -> infoZonas: ", infoZonas);
    
    // PASO 0: Filtramos primero las zonas que NO están habilitadas.
    // Solo trabajaremos con las que tengan hab != 0 (o true).
    const zonasActivas = infoZonas.filter(zona => zona.hab !== 0);
    //console.log("generarSeriesZonas -> zonasActivas: ", zonasActivas);
    
    // 1. Inicializamos el acumulador SOLO con las zonas activas
    const acumuladorZonas = {};
    zonasActivas.forEach(info => {
        acumuladorZonas[info.nZona] = [];
    });
    //console.log("generarSeriesZonas -> acumuladorZonas: ", acumuladorZonas);

    // 2. Recorremos tus eventos
    arrayRegistros.forEach(registro => {
        const timestamp = new Date(registro.date).getTime() - (4 * 60 * 60 * 1000);
        //console.log("registro.zonas: ", registro.zonas);

        /*const zonasRaw = registro.zonas.split('*').filter(z => z.length > 0);

        zonasRaw.forEach(zonaStr => {
            const params = zonaStr.split('!');

            const idZona = parseInt(params[0], 16);
            const valorMovimiento = parseInt(params[4], 16);
            if(valorMovimiento > maxMovimientosValue)
                maxMovimientosValue = valorMovimiento;

            // IMPORTANTE: Como 'acumuladorZonas' solo tiene claves de las zonas activas,
            // si llega una zona deshabilitada (que no está en el objeto), 
            // esta condición será falsa y se ignorará automáticamente.
            if (acumuladorZonas[idZona]) {
                acumuladorZonas[idZona].push([timestamp, valorMovimiento]);
            }
        });
        */
        const zonasRaw = procesarTramaZonas(registro);
        //console.log("zonasRaw: ", zonasRaw);

        zonasRaw.forEach(zonaObj => {
            const idZona = zonaObj.numZona;
            const valorMovimiento = zonaObj.cuentaParcial;
            if(valorMovimiento > maxMovimientosValue)
                maxMovimientosValue = valorMovimiento;

            // IMPORTANTE: Como 'acumuladorZonas' solo tiene claves de las zonas activas,
            // si llega una zona deshabilitada (que no está en el objeto), 
            // esta condición será falsa y se ignorará automáticamente.
            if (acumuladorZonas[idZona]) {
                acumuladorZonas[idZona].push([timestamp, valorMovimiento]);
            }
        });

    });

    // 3. Generamos las series usando solo 'zonasActivas'
    const seriesApex = zonasActivas.map(info => {
        return {
            name: info.desCorta,
            data: acumuladorZonas[info.nZona]
        };
    });

    maxMovimientosValue = maxMovimientosValue + 1;

    return seriesApex;
}


/**
 * Genera las opciones para el gráfico de Zonas
 * @param {Array} seriesZonas - El array de datos generado por 'generarSeriesZonas'
 */
export function generarOpcionesZonas(seriesZonas) {

    // 1. CALCULAMOS EL MÁXIMO GLOBAL
    // Recorremos todas las zonas para encontrar el valor más alto de "cuentaParcial"
    let maxValorGlobal = 0;

    if (seriesZonas && seriesZonas.length > 0) {
        seriesZonas.forEach(serie => {
            // serie.data es un array de arrays: [[timestamp, valor], [timestamp, valor]]
            const maxLocal = serie.data.reduce((max, punto) => Math.max(max, punto[1]), 0);
            if (maxLocal > maxValorGlobal) {
                maxValorGlobal = maxLocal;
            }
        });
    }

    // 2. DEFINIMOS EL TECHO Y LOS TICKS
    // Si el valor máximo es 0 (todo vacío), ponemos 5 para que no se rompa.
    // Agregamos un 10% de margen superior.
    const techo = maxValorGlobal === 0 ? 5 : Math.ceil(maxValorGlobal * 1.1);

    //console.log({techo, maxValorGlobal});

    // Lógica "Pixel Perfect":
    // Si hay pocos datos (ej: máx 4), forzamos 4 líneas.
    // Si hay muchos (ej: 100), dejamos que Apex ponga 5 líneas automáticas.
    let cantidadTicks = undefined;

    if (techo <= 15) {
        cantidadTicks = techo;
    } else {
        cantidadTicks = 5;
    }

    // 3. RETORNAMOS EL OBJETO OPTIONS
    return {
        chart: {
            type: 'line',
            height: 350,
            zoom: { enabled: true },
            animations: { enabled: false } // Para carga instantánea
        },
        stroke: {
            //Se pueden definir arrays si se quiere mezclar tipos de líneas (smooth, straight, stepline)
            curve: 'straight', // 'smooth' para picos curvos o 'straight' si prefieres picos rectos
            width: 2
        },
        title: {
            text: 'Actividad por Zona',
            align: 'left'
        },
        xaxis: {
            type: 'datetime',
            tooltip: { enabled: false }
        },
        yaxis: {
            min: 0,
            max: techo,

            // La clave para que no se desfase visualmente (4 vs 3.6)
            tickAmount: cantidadTicks,

            // Solo forzamos saltos de 1 si es una escala pequeña
            stepSize: techo <= 15 ? 1 : undefined,

            decimalsInFloat: 0, // Prohibido decimales
            forceNiceScale: true,

            labels: {
                style: { colors: ['#000'] },
                formatter: (value) => value.toFixed(0)
            },
            title: {
                text: "Eventos"
            }
        },
        // Colores automáticos (o puedes definir tu propia paleta aquí)
        //colors: ['#00E396', '#FEB019', '#FF4560', '#775DD0', '#008FFB'],
        colors: ['#7196AB', '#008FFB', '#00E396', '#FEB019', '#AC82BD', '#775DD0'],

        tooltip: {
            shared: true,
            intersect: false,
            x: { format: 'HH:mm:ss' },
            y: {
                formatter: (val) => val !== undefined ? val.toFixed(0) : val
            }
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right'
        },
        dataLabels: {
            enabled: false
        }
    };
}


/**
 * Genera la serie para graficar el estado de la alarma
 * @param {Array} arrayRegistros - Array con objetos { date, aEst, ... }
 * @returns {Array} Formato para ApexCharts [{ name: 'Estado', data: [...] }]
 */
export function generarSerieEstado(arrayRegistros) {

    maxEstadosValue = 0;

    // 1. SOLUCIÓN: Ordenamos los eventos por fecha antes de hacer nada más.
    // Usamos [...arrayRegistros] para crear una copia y no alterar el array original.
    //const eventosOrdenados = [...arrayRegistros].sort((a, b) =>
    //    new Date(a.date).getTime() - new Date(b.date).getTime()
    //);
    const eventosOrdenados = [...arrayRegistros].sort((a, b) =>
        a.id - b.id
    );

    const dataPuntos = eventosOrdenados.map(registro => {
        // Protección básica
        if (!registro.date || registro.aEst === undefined) return null;

        const timestamp = new Date(registro.date).getTime() - (4 * 60 * 60 * 1000);

        // Convertimos el estado de Hexadecimal a Decimal
        //const estadoIndex = parseInt(registro.aEst, 16);
        const estadoIndex = parseInt(registro.aEst);
        if(estadoIndex > maxEstadosValue)
            maxEstadosValue = estadoIndex;

        return [timestamp, estadoIndex];
    }).filter(punto => punto !== null); // Eliminamos nulos si hubo errores

    maxEstadosValue = maxEstadosValue + 1;

    //console.log({arrayRegistros, dataPuntos});
    
    return [{
        name: "Estado del Sistema",
        data: dataPuntos
    }];
}

/**
* Genera la configuración para el gráfico de Estados
* @param {Array} listaEstados - Tu array con los textos (ej: ["Desarmada", "Armada", ...])
*/
export function generarOpcionesEstados(listaEstados) {

    // Calculamos dinámicamente el tope del gráfico
    // Si tienes 10 estados (índices 0-9), el max debe ser 9.
    //const maxValor = listaEstados.length > 0 ? listaEstados.length - 1 : 10;

    //console.log("maxEstadosValue: ", maxEstadosValue);

    return {
        chart: {
            type: 'line',
            height: 350,
            zoom: { enabled: true },
            animations: { enabled: false } // "Digital" look
        },
        stroke: {
            curve: 'stepline',
            width: 3
        },
        title: {
            text: 'Historial de Estados de Alarma',
            align: 'left'
        },
        xaxis: {
            type: 'datetime',
        },
        yaxis: {
            min: 0,

            // --- AQUÍ ESTÁ LA MAGIA DINÁMICA ---
            max: maxEstadosValue,
            tickAmount: maxEstadosValue,
            // -----------------------------------

            stepSize: 1,
            decimalsInFloat: 0,
            labels: {
                formatter: (value) => {
                    // Aseguramos que sea un entero para buscar en el array
                    const index = Math.floor(value);
                    // Devolvemos el texto correspondiente o el número si no existe
                    //return CE_ESTADOS_ALARMA[index] || value;
                    return estadosAlarma[index] || value;
                },
                style: {
                    colors: ['#000'], // Color del texto
                    fontSize: '12px',
                    fontWeight: 600
                }
            }
        },
        colors: ['#546E7A'],
        tooltip: {
            x: { format: 'HH:mm:ss' },
            y: {
                formatter: (value) => {
                    return listaEstados[value] || value;
                }
            }
        },
        // Annotations se mantienen igual (o podrías pasarlas como param si quisieras)
        annotations: {
            yaxis: [
                {
                    y: 2, // Ojo: Asegúrate que el índice 2 siga siendo "Alarmada" en tu array nuevo
                    borderColor: '#FF4560',
                    label: {
                        borderColor: '#FF4560',
                        style: { color: '#fff', background: '#FF4560' },
                        text: 'PELIGRO'
                    }
                }
            ]
        }
    };
}

export function generarSeriesSalac(arrayRegistros, infoLuces) {
    
    // PASO 0: Filtramos primero las luces que SÍ están habilitadas.
    const lucesActivas = infoLuces.filter(luz => luz.hab !== 0);
    
    // 1. Inicializamos el acumulador SOLO con las luces activas
    const acumuladorLuces = {};
    lucesActivas.forEach(info => {
        acumuladorLuces[info.id] = [];
    });

    // 2. Recorremos los eventos
    arrayRegistros.forEach(registro => {
        const timestamp = new Date(registro.date).getTime() - (4 * 60 * 60 * 1000);

        // AQUÍ ASUMO que tienes una función o accedes a la propiedad del registro
        // Adapta esta línea según cómo obtengas el array de las luces del registro.
        // Ejemplo: const lucesRaw = procesarTramaLuces(registro);
        const lucesRaw = procesarTramaLuces(registro)  || []; 

        lucesRaw.forEach(luzObj => {
            const idLuz = luzObj.numLuz;
            const estado = luzObj.estadoLuz;

            // Si la luz está habilitada (existe en el acumulador), guardamos el punto
            if (acumuladorLuces[idLuz]) {
                acumuladorLuces[idLuz].push([timestamp, estado]);
            }
        });
    });

    // 3. Generamos las series usando solo 'lucesActivas'
    const seriesApex = lucesActivas.map(info => {
        return {
            // Usamos descCorta o un nombre por defecto si está vacío
            name: (info.descCorta && info.descCorta !== "---") ? info.descCorta : `Luz ${info.id}`,
            data: acumuladorLuces[info.id]
        };
    });

    return seriesApex;
}

export function generarOpcionesSalac(seriesLuces) {

    // 1. CALCULAMOS EL MÁXIMO GLOBAL
    let maxValorGlobal = 0;

    if (seriesLuces && seriesLuces.length > 0) {
        seriesLuces.forEach(serie => {
            const maxLocal = serie.data.reduce((max, punto) => Math.max(max, punto[1]), 0);
            if (maxLocal > maxValorGlobal) {
                maxValorGlobal = maxLocal;
            }
        });
    }

    // 2. DEFINIMOS EL TECHO
    // Como las luces normalmente son 0 (Apagado) o 1 (Encendido), el techo por defecto debe ser 1.
    const techo = maxValorGlobal === 0 ? 1 : maxValorGlobal;

    // 3. RETORNAMOS EL OBJETO OPTIONS
    return {
        chart: {
            type: 'line',
            height: 350,
            zoom: { enabled: true },
            animations: { enabled: false }
        },
        stroke: {
            // CAMBIO CLAVE: 'stepline' es ideal para visualizar estados ON/OFF (señales cuadradas)
            curve: 'stepline', 
            width: 2
        },
        title: {
            text: 'Estado de Luces',
            align: 'left'
        },
        xaxis: {
            type: 'datetime',
            tooltip: { enabled: false }
        },
        yaxis: {
            min: 0,
            max: techo,
            
            // Si el valor máximo es 1, queremos 1 tick (para ver la línea del 0 y del 1). 
            tickAmount: techo,
            decimalsInFloat: 0,
            forceNiceScale: false,

            labels: {
                style: { colors: ['#000'] },
                formatter: (value) => {
                    // Opcional: Mostrar texto en lugar de números si es 0 o 1
                    if (value === 0) return "Off";
                    if (value === 1) return "On";
                    return value.toFixed(0);
                }
            },
            title: {
                text: "Estado"
            }
        },
        // Usamos una paleta de colores ligeramente distinta para diferenciar visualmente de las zonas
        colors: ['#FEB019', '#00E396', '#008FFB', '#FF4560', '#775DD0', '#AC82BD'],

        tooltip: {
            shared: true,
            intersect: false,
            x: { format: 'HH:mm:ss' },
            y: {
                formatter: (val) => {
                    if (val === undefined || val === null) return val;
                    // Muestra "Encendido/Apagado" en el recuadro flotante
                    if (val === 1) return "Encendido";
                    if (val === 0) return "Apagado";
                    return val.toFixed(0);
                }
            }
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right'
        },
        dataLabels: {
            enabled: false
        }
    };
}







/**
 * Funcion que genera los datos combinados de zonas y estado de la alarma para un solo gráfico
 * @param {*} arrayRegistros 
 * @param {*} infoZonas 
 * @returns 
 */
export function generarDatosCombinados(arrayRegistros, infoZonas) {

    // 1. Ordenamos cronológicamente para evitar líneas que retroceden
    //const eventosOrdenados = [...arrayRegistros].sort((a, b) =>
    //    new Date(a.date).getTime() - new Date(b.date).getTime()
    //);
    const eventosOrdenados = [...arrayRegistros].sort((a, b) =>
        a.id - b.id
    );

    // --- GENERACIÓN DE ALARMA (Datos Reales) ---
    const dataAlarma = eventosOrdenados.map(registro => {
        if (!registro.date || registro.aEst === undefined) return null;

        // Usamos el dato EXACTO del registro. 
        // Si a las 10:05 dice "Delay", graficamos "Delay" a las 10:05.
        return [
            new Date(registro.date).getTime() - (4 * 60 * 60 * 1000),
            parseInt(registro.aEst, 16)
        ];
    }).filter(Boolean); // Filtramos nulos

    const serieAlarma = {
        name: "Estado del Sistema",
        type: 'line',
        data: dataAlarma
    };

    // --- GENERACIÓN DE ZONAS (Datos Reales) ---
    const zonasActivas = infoZonas.filter(z => z.hab !== 0);
    const acumuladorZonas = {};
    zonasActivas.forEach(info => acumuladorZonas[info.nZona] = []);

    eventosOrdenados.forEach(registro => {
        const timestamp = new Date(registro.date).getTime() - (4 * 60 * 60 * 1000);

        const zonasRaw = procesarTramaZonas(registro);
        //console.log("zonasRaw: ", zonasRaw);

        zonasRaw.forEach(zonaObj => {
            const idZona = zonaObj.numZona;
            const cuentaParcial = zonaObj.cuentaParcial;
            //if(cuentaParcial > maxMovimientosValue)
            //    maxMovimientosValue = cuentaParcial;

            // IMPORTANTE: Como 'acumuladorZonas' solo tiene claves de las zonas activas,
            // si llega una zona deshabilitada (que no está en el objeto), 
            // esta condición será falsa y se ignorará automáticamente.
            if (acumuladorZonas[idZona]) {
                acumuladorZonas[idZona].push([timestamp, cuentaParcial]);
            }
        }); 
        
        /*
        const zonasRaw = registro.zonas.split('*').filter(z => z.length > 0);

        zonasRaw.forEach(zonaStr => {
            const params = zonaStr.split('!');
            const idZona = parseInt(params[0], 16);
            const cuentaParcial = parseInt(params[4], 16);

            if (acumuladorZonas[idZona]) {
                acumuladorZonas[idZona].push([timestamp, cuentaParcial]);
            }
        });
        */
    });

    const seriesZonas = zonasActivas.map(info => ({
        name: info.desCorta || `Zona ${info.nZona}`,
        type: 'line',
        data: acumuladorZonas[info.nZona]
    }));

    return [...seriesZonas, serieAlarma];
}


/**
 * Función para generar el objeto de opciones para el gráfico combinado de zonas y estados de la alarma
 * @param {*} seriesGeneradas 
 * @returns 
 */
export function generarOpcionesCombinadas(seriesGeneradas) {
    
    const totalSeries = seriesGeneradas.length;
    const indexAlarma = totalSeries - 1; 

    //console.log(`seriesGeneradas: `, seriesGeneradas);

    const curvas = [...Array(totalSeries - 1).fill('straight'), 'stepline'];
    const anchos = [...Array(totalSeries - 1).fill(2), 3];

    // --- NUEVO: CREACIÓN DINÁMICA DE COLORES ---
    // 1. Definimos los colores para las zonas
    const paletaZonas = ['#7196AB', '#008FFB', '#00E396', '#FEB019', '#AC82BD', '#775DD0',  '#ACACBD', '#77F3D0'];
    
    // 2. Llenamos un nuevo arreglo de colores según la cantidad de zonas
    const coloresGrafico = [];
    for (let i = 0; i < indexAlarma; i++) {
        // El módulo (%) hace que si tienes más zonas que colores, vuelva a empezar la paleta
        coloresGrafico.push(paletaZonas[i % paletaZonas.length]);
    }
    
    // 3. Agregamos el rojo de la alarma SIEMPRE al final
    coloresGrafico.push('#FF4560');
    // -------------------------------------------

    let maxValorZonas = 0;
    for (let i = 0; i < indexAlarma; i++) {
        const dataZona = seriesGeneradas[i].data;
        const maxLocal = dataZona.reduce((max, punto) => Math.max(max, punto[1]), 0);
        if (maxLocal > maxValorZonas) maxValorZonas = maxLocal;
    }

    const techoZonas = maxValorZonas === 0 ? 5 : Math.ceil(maxValorZonas * 1.1);
    let ticksZonas = techoZonas <= 15 ? techoZonas : 5;

    const yaxisConfig = seriesGeneradas.map((serie, index) => {
        if (index === indexAlarma) {
            return {
                seriesName: serie.name,
                opposite: true,
                title: { text: "Estado Alarma" },
                min: 0,
                max: 10,
                decimalsInFloat: 0,
                tickAmount: 10,
                labels: {
                    style: { colors: '#FF4560' }, // Mantenemos la etiqueta roja
                    align: 'left',
                    formatter: (value) => {
                        if (value % 1 !== 0) return "";
                        return estadosAlarma[value] || "";
                    }
                }
            };
        }

        return {
            seriesName: serie.name,
            opposite: false,
            min: 0,
            max: techoZonas,
            tickAmount: ticksZonas,
            stepSize: techoZonas <= 15 ? 1 : undefined,
            decimalsInFloat: 0,
            forceNiceScale: true,
            show: index === 0,
            title: { text: index === 0 ? "Cuenta Parcial" : undefined },
            labels: {
                style: { colors: '#000000' },
                formatter: (val) => val.toFixed(0)
            },
        };
    });

    return {
        chart: { type: 'line', height: 350, animations: { enabled: false } },
        dataLabels: { enabled: false },
        fill: { type: 'solid', opacity: 1 },
        stroke: { curve: curvas, width: anchos },
        xaxis: { type: 'datetime', tooltip: { enabled: false } },
        yaxis: yaxisConfig,
        tooltip: {
            shared: true,
            intersect: false,
            x: { format: 'dd MMM HH:mm:ss' },
            y: {
                formatter: function (val, { seriesIndex }) {
                    if (val === undefined || val === null) return;
                    if (seriesIndex === indexAlarma) return estadosAlarma[val] || "Desc";
                    return val.toFixed(0);
                }
            }
        },
        // --- AQUÍ ASIGNAMOS EL ARREGLO DINÁMICO ---
        colors: coloresGrafico
    };
}


/**
 * Función reutilizable para formatear fechas
 * @param {string} fechaISO - Ej: "2026-01-27T23:11:10.000Z"
 * @returns {string} - Ej: "27/01/2026 19:11:10"
 */
export const formatearFecha = (fechaISO) => {
    if (!fechaISO) return "Sin fecha";

    // Convertimos la fecha UTC a la zona horaria de Bolivia (GMT-4)
    // y le damos el formato deseado
    return dayjs(fechaISO)
        .tz("America/La_Paz") 
        .format("DD/MM/YYYY HH:mm:ss");
};


/*****************************************************************************************************************
 * Ejemplos de configuración de opciones y datos para gráficos
 *****************************************************************************************************************/

/*
// 2. La configuración visual (Opciones)
const [options] = useState({
    chart: {
        type: 'line', // 'area' O 'line'
        height: 350,
        zoom: { enabled: true }
    },
    stroke: {
        curve: 'straight',    // 'straight' para lineas rectas, 'smooth' para curvas suaves
        width: 2 // Grosor de las líneas
    },
    xaxis: {
        type: 'datetime',
        tooltip: {
            enabled: true,
            shared: true,
            intersect: false
        }
    },
    // Tip PRO: Yaxis array para poner escalas diferentes si los valores son muy distintos
    yaxis: [
        {
            title: { text: "Movimiento" },
            labels: { formatter: (val) => val.toFixed(1) }
        },
        // Si la humedad y temperatura tienen rangos parecidos, puedes borrar este segundo objeto
        // y dejar solo uno. Pero si son muy distintos, esto ayuda.
        //{
        //    opposite: true, // Pone el eje a la derecha
        //    title: { text: "Humedad (%)" }
        //}
    ],
    colors: ['#FF4560', '#00E396', '#234567'], // Color para Temp (Rojo) y Humedad (Verde)
    tooltip: {
        enabled: true,
        shared: true,      // Muestra todas las series juntas
        intersect: false,  // IMPORTANTE: Permite activar el tooltip sin tocar el punto exacto
        x: {
            format: 'dd MMM HH:mm:ss' // Opcional: Para formatear la fecha en el encabezado
        }
    },
    dataLabels: {
        enabled: false
    },
});




const [seriesEstados] = useState([
    {
        name: "Estado del Sistema",
        data: [
            // Simulamos un flujo de uso real
            [new Date('2026-01-12T08:00').getTime(), 0], // Estaba desarmada
            [new Date('2026-01-12T08:30').getTime(), 4], // Empieza el delay de salida (4)
            [new Date('2026-01-12T08:31').getTime(), 1], // Se armó (1)
            [new Date('2026-01-12T14:15').getTime(), 1], // Sigue armada...
            [new Date('2026-01-12T14:20').getTime(), 2], // ¡Saldó la alarma! (2)
            [new Date('2026-01-12T14:25').getTime(), 0], // Alguien la desactivó (0)
        ]
    }
]);

const [optionsEstadosAlarma] = useState({
    chart: {
        type: 'line',
        height: 350,
        zoom: { enabled: true },
        animations: {
            enabled: false // Tip: Para cambios de estado bruscos, quitar la animación se ve más "digital"
        }
    },
    stroke: {
        curve: 'stepline', // ¡CLAVE! Esto hace que la línea sea cuadrada (escalones)
        width: 3
    },
    title: {
        text: 'Historial de Estados de Alarma',
        align: 'left'
    },
    xaxis: {
        type: 'datetime',
    },
    yaxis: {
        //tickAmount: 4, // Intenta forzar pocas líneas horizontales para que no salgan decimales
        min: 0,        // Mínimo valor (Desarmada)
        max: 10,       // Máximo valor (Transitorio)
        stepSize: 1,  // Para graficar todos los valores, no de 2 en 2 por ejemplo
        tickAmount: 10, // <--- Ayuda a ApexCharts a dividir el espacio correctamente
        decimalsInFloat: 0, // Evitar decimales fantasmas (ej: 0.5)
        labels: {
            formatter: (value) => {
                // Aseguramos que sea un entero para buscar en el array
                const index = Math.floor(value);
                // Devolvemos el texto correspondiente o el número si no existe
                //return CE_ESTADOS_ALARMA[index] || value;
                return estadosAlarma[index] || value;
            },
            style: {
                colors: ['#000'], // Color del texto
                fontSize: '12px',
                fontWeight: 600
            }
        }
    },
    colors: ['#546E7A'],
    tooltip: {
        x: { format: 'HH:mm:ss' },
        y: {
            formatter: (value) => {
                return estadosAlarma[value]; // Para que en la cajita flotante también salga el texto
            }
        }
    },
    // Opcional: Colorear zonas según gravedad (Annotations)
    annotations: {
        yaxis: [
            {
                y: 2, // Altura de "Alarmada"
                borderColor: '#FF4560',
                label: {
                    borderColor: '#FF4560',
                    style: { color: '#fff', background: '#FF4560' },
                    text: 'PELIGRO'
                }
            }
        ]
    }
});
*/

export function generarSeriesPuertas(arrayRegistros, infoPuertas) {
    
    // 1. Filtramos las puertas habilitadas
    const puertasActivas = infoPuertas.filter(puerta => puerta.hab !== 0);
    
    // 2. Inicializamos el acumulador
    const acumuladorPuertas = {};
    puertasActivas.forEach(info => {
        acumuladorPuertas[info.nAcceso] = [];
    });

    // 3. Ordenamos cronológicamente
    const eventosOrdenados = [...arrayRegistros].sort((a, b) => a.id - b.id);

    // 4. Recorremos eventos
    eventosOrdenados.forEach(registro => {
        // CORREGIDO: Quitamos la barra "/" que estaba antes de const
        const fechaCruda = registro.fechaTrama || registro.date;
        
        // Si por alguna razón el registro no tiene fecha, lo ignoramos para no generar NaN
        if (!fechaCruda) return; 

        const timestamp = new Date(fechaCruda).getTime() - (4 * 60 * 60 * 1000);
        const puertasRaw = procesarTramaPuertas(registro);

        puertasRaw.forEach(puertaObj => {
            const idPuerta = puertaObj.numPuerta;

            if (acumuladorPuertas[idPuerta]) {
                acumuladorPuertas[idPuerta].push({
                    x: timestamp,
                    y: puertaObj.estadoFlujo,
                    extraData: puertaObj 
                });
            }
        });
    });

    // 5. Generamos las series
    return puertasActivas.map(info => ({
        name: (info.desc && info.desc !== "---") ? info.desc : `Puerta ${info.nAcceso}`,
        data: acumuladorPuertas[info.nAcceso]
    }));
}

export function generarOpcionesPuertas(seriesPuertas) {

    // Diccionario de estados de la máquina
    const ESTADOS_PUERTA = {
        0: "Estado Cero",
        1: "Cerrada",
        2: "Pulso Abrir",
        3: "Abrir Puerta",
        4: "Espera Abrir",
        5: "No Abierta",
        6: "Espera Cerrar",
        7: "No Cerrada",
        8: "Cerrada Tarde",
        9: "Abierta s/Aut",
        10: "Cerrándose"
    };

    // NUEVO: Diccionario para los métodos de apertura
    const METODOS_APERTURA = {
        0: "Desconocido",
        2: "MQTT",
        4: "Bluetooth (BLE)",
        6: "Telegram",
        8: "Teclado / Clave",
        50: "Botón Físico",
        52: "Lector de Huella"
    };

    return {
        chart: {
            type: 'line',
            height: 350,
            zoom: { enabled: true },
            animations: { enabled: false },
            events: {
                dataPointSelection: function(event, chartContext, config) {
                    const dataPunto = config.w.config.series[config.seriesIndex].data[config.dataPointIndex];
                    if(dataPunto && dataPunto.extraData) {
                        //console.log("Información detallada de la puerta:", dataPunto.extraData);
                    }
                }
            }
        },
        stroke: {
            curve: 'stepline',
            width: 2
        },
        title: {
            text: 'Máquina de Estados: Accesos y Puertas',
            align: 'left'
        },
        xaxis: {
            type: 'datetime',
            tooltip: { enabled: false }
        },
        yaxis: {
            min: 0,
            max: 10,
            tickAmount: 10,
            decimalsInFloat: 0,
            forceNiceScale: false,
            labels: {
                style: { colors: ['#000'] },
                formatter: (value) => {
                    if (value % 1 !== 0) return ""; 
                    return ESTADOS_PUERTA[value] || value;
                }
            },
            title: {
                text: "Estado del Flujo"
            }
        },
        colors: ['#008FFB', '#00E396', '#775DD0', '#FEB019', '#FF4560'],
        
        // TOOLTIP PERSONALIZADO (Hover)
        // TOOLTIP PERSONALIZADO (Hover)
        tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
                const punto = w.config.series[seriesIndex].data[dataPointIndex];
                if (!punto) return '';

                const extra = punto.extraData;
                const estadoTxt = ESTADOS_PUERTA[punto.y] || "Desconocido";
                const estadoFisico = extra.estadoBinario === 1 ? "Abierta 🔓" : "Cerrada 🔒";
                const horaStr = new Date(punto.x).toLocaleTimeString();

                const metodoTxt = METODOS_APERTURA[extra.metodoApertura] || `Otro (${extra.metodoApertura})`;
                
                // NUEVO: Si el método es 0 (Desconocido), no agregamos nada. 
                // Si es distinto, agregamos la línea completa en HTML.
                const lineaMetodoHtml = extra.metodoApertura === 0 
                    ? '' 
                    : `<b>Método:</b> ${metodoTxt} <br/>`;

                return `
                    <div style="padding: 12px; background: white; border: 1px solid #e2e8f0; border-radius: 6px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
                        <div style="font-weight: bold; margin-bottom: 8px; color: #1e293b; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px;">
                            ${w.config.series[seriesIndex].name} - ${horaStr}
                        </div>
                        <div style="font-size: 13px; color: #334155; line-height: 1.5;">
                            <b>Máquina:</b> ${estadoTxt} <br/>
                            <b>Físicamente:</b> ${estadoFisico} <br/>
                            <b>Usuario (ID):</b> ${extra.usuarioApertura} <br/>
                            ${lineaMetodoHtml}
                            <b>Resultado:</b> ${extra.resultadoApertura} <br/>
                            <b>Tiempo Abierta:</b> <span style="color: ${extra.timeAnormal > 0 ? '#ef4444' : '#334155'}">${extra.timeAnormal} seg</span>
                        </div>
                    </div>
                `;
            }
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right'
        },
        dataLabels: {
            enabled: false
        }
    };
}